module.exports = __webpack_public_path__ + "static/media/vida-vacations-white.32064adb.svg";